import classNames from 'classnames';
import NextLink, {LinkProps as NextLinkProps} from 'next/link';
import React, {PropsWithChildren} from 'react';

export interface LinkProps extends NextLinkProps {
    className?: string;
    title?: string;
    target?: string;
    variant?: 'button';
}

interface WebViewLinkProps extends NextLinkProps {
    webViewNavigation?: boolean;
    webViewData?: string;
}

const Link: React.FC<WebViewLinkProps & LinkProps & PropsWithChildren<{}>> = ({
    children,
    variant,
    title,
    target,
    className,
    passHref,
    prefetch = true,
    webViewNavigation,
    webViewData,
    ...props
}) => {
    const {href, onClick} = props;
    if (typeof href !== 'string') {
        throw new Error('href is required' + children);
    }
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        const isNativeWebView =
            typeof window !== 'undefined' &&
            window.ReactNativeWebView &&
            typeof window.ReactNativeWebView.postMessage === 'function';

        if (webViewNavigation && typeof window !== 'undefined' && window.ReactNativeWebView) {
            e.preventDefault();
            window.ReactNativeWebView.postMessage(webViewData ?? 'no-webview-data');
            return;
        }

        onClick && onClick(e);
        // If not in WebView or webViewNavigation is false, do nothing special
    };
    return (
        <NextLink
            {...props}
            className={classNames(
                {
                    "focus:ring-accent-700' inline-flex h-9 shrink-0 items-center justify-center rounded border border-transparent bg-accent px-3 py-0 text-sm font-semibold leading-none text-white outline-none transition duration-300 ease-in-out hover:bg-accent-hover focus:shadow focus:outline-none focus:ring-1":
                        variant === 'button',
                },
                className,
            )}
            title={title}
            target={target}
            passHref={passHref}
            prefetch={prefetch}
            onClick={handleClick}>
            {children}
        </NextLink>
    );
};

export default Link;
